import store from '../../store/store'

export const alphaNumericPattern: RegExp = /^[a-zA-Z0-9_ .-]*$/
export const alphabet: RegExp = /^[A-Za-z\s]+$/
export const number: RegExp = /^[0-9]/
export const email: RegExp =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,6}))$/
export const password: RegExp =
  /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-])/

// global

export const getAddEmployeeUserId = () => store?.getState()?.common?.userId

export const getAddEmployeeEmployeeId = () => store?.getState()?.common?.empId

export const handlePhoneNumberChange = (e: any) => {
  const inputValue = e.target.value
  const numericValue = inputValue.replace(/[^0-9]/g, '')
  e.target.value = numericValue
}
export const handleAlphabetChange = (e: any) => {
  const inputValue = e.target.value
  const alphabeticValue = inputValue.replace(/[^a-zA-Z]/g, '')
  e.target.value = alphabeticValue
}

export const SpecialCharacters = /[`~!@#$%^&*()_|+\-=?;:'",.<>\{\}\[\]\\\/]/gi
export const lowerCase = /[a-z]/
export const upperCase = /[A-Z]/
